import { createPermission } from '@backstage/plugin-permission-common';

export const GROUP_RESOURCE_TYPE = 'group-entity';

export const keycloakGroupsReadPermission = createPermission({
  name: 'keycloak.groups.read',
  attributes: { action: 'read' },
});

export const keycloakGroupsCreatePermission = createPermission({
  name: 'keycloak.groups.create',
  attributes: { action: 'create' },
});

export const keycloakGroupsUpdatePermission = createPermission({
  name: 'keycloak.groups.update',
  attributes: { action: 'update' },
  resourceType: GROUP_RESOURCE_TYPE,
});

export const keycloakGroupsDeletePermission = createPermission({
  name: 'keycloak.groups.delete',
  attributes: { action: 'delete' },
  resourceType: GROUP_RESOURCE_TYPE,
});

export const keycloakGroupsPermissions = {
  keycloakGroupsReadPermission,
  keycloakGroupsCreatePermission,
  keycloakGroupsUpdatePermission,
  keycloakGroupsDeletePermission,
};
